export default __webpack_public_path__ + "static/media/IR_Transmitter.1323bbec.svg";